module.exports = __webpack_public_path__ + "static/media/calculator-result-under-age-12.df6e8328.png";